import { useParams } from "react-router-dom";
import { EditOrganizationContainer } from "./container";

export const EditOrganizationPane = (props: {}) => {
  const params = useParams();
  const { organizationId } = params;
  if (organizationId === undefined) return null;
  return <EditOrganizationContainer organizationId={organizationId} />;
};
